// The face of the wheel the player picked to read. The hand of the wide
// layout shows it as a card. Null means the hand shows the held card.

import { createStore } from '../lib/store';

export const wheelPickStore = createStore<number | null>(null);

export const setWheelPick = (face: number | null): void => {
  if (wheelPickStore.get() !== face) wheelPickStore.set(face);
};
